export function luhnCheck(val) {
    // return Boolean(val);
    let sum = 0;
    for (let i = 0; i < val.length; i++) {
        let intVal = Number(val.substr(i, 1));
        if (i % 2 === 0) {
            intVal *= 2;
            if (intVal > 9) {
                intVal = 1 + (intVal % 10);
            }
        }
        sum += intVal;
    }
    return (sum % 10) === 0;
}
